(function () {
    'use strict';

    angular
        .module('elogbooks.admin.waste-management')
        .controller('TreatmentTypesController', TreatmentTypesController);

    TreatmentTypesController.$inject = ['$state', '$stateParams', '$filter', 'treatmentTypeCollectionResponse'];

    function TreatmentTypesController($state, $stateParams, $filter, treatmentTypeCollectionResponse) {
        var vm = this;

        vm.treatmentTypes = treatmentTypeCollectionResponse.treatmentTypes;
        vm.treatmentTypesCollectionResponse = treatmentTypeCollectionResponse;

        vm.order = order;
        vm.search = search;

        var statuses = [
            {
                title: $filter('translate')('STATUS_ACTIVE'),
                value: 'true'
            },
            {
                title: $filter('translate')('STATUS_INACTIVE'),
                value: 'false'
            },
            {
                title: $filter('translate')('NONE_SELECTED'),
                value: null
            }
        ];

        vm.criteria = {
            id: { type: 'number', value: $stateParams.id ? parseInt($stateParams.id, 10) : null, title: 'ID', min: 1 },
            name: { type: 'text', value: $stateParams.name, title: 'NAME' },
            status: { type: 'options', title: 'IS_ACTIVE', value: $stateParams.status, options: statuses }
        };

        function search(params) {
            var override = {
                page: 1
            };

            $state.go('.', angular.extend({}, params, override), {reload: $state.current});
        };

        function order(key) {
            $stateParams.order = key;

            $state.go('.', angular.extend({}, $stateParams), {reload: $state.current});
        };
    }
})();
